import * as actionTypes from "../actions/actionTypes";

const analytics = store => next => action => {
    switch (action.type) {
        case actionTypes.LOGIN_SUCCESS:
            ga('send', 'pageview', '/accounts/login/success/');
            break;

        case actionTypes.SIGNUP_SUCCESS:
            ga('send', 'pageview', '/accounts/signup/success/');
            break;

        case actionTypes.UPGRADE_BILLING_SUCCESS:
            ga('send', 'pageview', '/accounts/upgrade/success/');
            break;

        case actionTypes.SET_SEARCH_QUERY:
            ga('send', 'pageview', '/search/?q=' + action.query);
            break;

        case actionTypes.REPORT_PLUGIN_USAGE:
            ga('send', 'event', 'icon', 'placed');
            break;
    }

    return next(action);
};

export default analytics;
